module.exports = __webpack_public_path__ + "img/banner.c496366e.jpg";